// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Stack, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

interface Props {
  /**
   * The title to display in the empty state.
   */
  title: string;

  /**
   * The message to display in the empty state.
   */
  message?: string;
}

/**
 * An empty state component that displays a title and message in a vertical
 * stack.
 */
export function EmptyState(props: PropsWithChildren<Props>) {
  return (
    <Stack spacing={2} paddingY={4} alignItems="center">
      <Typography variant="h6" color="text.secondary">
        {props.title}
      </Typography>
      {props.message && (
        <Typography variant="body1" color="text.secondary">
          {props.message}
        </Typography>
      )}
      {props.children}
    </Stack>
  );
}
